export const jobSalaryPeriodsCz = {
  jobSalaryPeriods: {
    'hour': 'Hodina',
    'day': 'Den',
    'week': 'Týden',
    'month': 'Měsíc',
    'year': 'Rok'
  }
};
